import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { css } from 'emotion';
import { useT } from 'client/i18n/hooks/useT';

export const CancelUploadConfirmationModal = ({
  hideConfirmationModal,
  onCancel,
  cancelUploadStatus,
}: {
  hideConfirmationModal: () => void;
  onCancel: () => void;
  cancelUploadStatus: string;
}) => {
  const t = useT();
  return (
    <Modal
      isShowing
      isShowingCloseButton
      onClose={hideConfirmationModal}
      aria-labelledby="cancel-upload-confirmation-title"
      size="small"
    >
      <Modal.Title id="cancel-upload-confirmation-title">
        {t(
          'EpisodeOptionsScreen.EpisodeContent.CancelUploadConfirmationModal.Title',
          'Cancel this upload?',
          'Cancel audio upload confirmation modal'
        )}
      </Modal.Title>
      {cancelUploadStatus === 'error' && (
        <Modal.Error>
          {t(
            'EpisodeOptionsScreen.EpisodeContent.ErrorMessage',
            'Something went wrong. Please try again.',
            'Generic error meesage'
          )}
        </Modal.Error>
      )}
      <Modal.Footer>
        <ButtonPrimary
          colorSet="negative"
          className={css`
            color: #ffffff !important;
          `}
          onClick={onCancel}
          disabled={cancelUploadStatus === 'loading'}
        >
          {t(
            'Button.CancelUpload',
            'Cancel upload',
            'Cancel upload button text'
          )}
        </ButtonPrimary>
      </Modal.Footer>
      {/* TODO: Add error messaging */}
    </Modal>
  );
};
